const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const ACCESS_TOKEN_EXPIRES_IN_KEY = "accessTokenExpiresIn";
const REFRESH_TOKEN_EXPIRATION_DATE_KEY = "refreshTokenExpirationDate";

interface TokenData {
  accessToken: string;
  refreshToken: string;
  accessTokenExpiresIn: number;
  refreshTokenExpirationDate: string;
}

export const tokenStore = {
  getAccessToken: () => localStorage.getItem(ACCESS_TOKEN_KEY),

  getRefreshToken: () => localStorage.getItem(REFRESH_TOKEN_KEY),

  getAccessTokenExpiresIn: () => {
    const expiresIn = localStorage.getItem(ACCESS_TOKEN_EXPIRES_IN_KEY);
    return expiresIn ? parseInt(expiresIn, 10) : null;
  },

  getRefreshTokenExpirationDate: () =>
    localStorage.getItem(REFRESH_TOKEN_EXPIRATION_DATE_KEY),

  setTokens: (data: TokenData) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, data.accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, data.refreshToken);
    localStorage.setItem(
      ACCESS_TOKEN_EXPIRES_IN_KEY,
      data.accessTokenExpiresIn.toString(),
    );
    localStorage.setItem(
      REFRESH_TOKEN_EXPIRATION_DATE_KEY,
      data.refreshTokenExpirationDate,
    );
  },

  setAccessToken: (token: string, expiresIn: number) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
    localStorage.setItem(ACCESS_TOKEN_EXPIRES_IN_KEY, expiresIn.toString());
  },

  clearTokens: () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(ACCESS_TOKEN_EXPIRES_IN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_EXPIRATION_DATE_KEY);
  },

  refreshTokenHasExpired: () => {
    const refreshTokenExpirationDate =
      tokenStore.getRefreshTokenExpirationDate();
    if (!refreshTokenExpirationDate) {
      return true;
    }
    return +refreshTokenExpirationDate < new Date().getTime();
  },

  accessTokenNeedsRefresh: () => {
    const accessToken = tokenStore.getAccessToken();
    const expiresIn = tokenStore.getAccessTokenExpiresIn();

    if (!accessToken || !expiresIn) {
      return true;
    }

    // Refresh if token expires in less than 60 seconds
    const tokenSetTime = localStorage.getItem(`${ACCESS_TOKEN_KEY}_setTime`);
    if (!tokenSetTime) {
      return true;
    }

    const elapsedSeconds = (Date.now() - parseInt(tokenSetTime, 10)) / 1000;
    const remainingSeconds = expiresIn - elapsedSeconds;

    return remainingSeconds < 60;
  },

  updateTokenSetTime: () => {
    localStorage.setItem(`${ACCESS_TOKEN_KEY}_setTime`, Date.now().toString());
  },
};

// For backward compatibility, export individual functions
export const getRefreshTokenExpirationDate =
  tokenStore.getRefreshTokenExpirationDate;
export const setRefreshTokenExpirationDate = (dateInMilliseconds: string) => {
  localStorage.setItem(REFRESH_TOKEN_EXPIRATION_DATE_KEY, dateInMilliseconds);
};
export const clearRefreshTokenExpirationDate = () => {
  localStorage.removeItem(REFRESH_TOKEN_EXPIRATION_DATE_KEY);
};
export const refreshTokenHasExpired = tokenStore.refreshTokenHasExpired;
